import Vue from 'vue'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import auth from './modules/auth'
import search from './modules/search'
import Profile from '@/services/apiCalls/profile/Profile'
import profileApi from '@/services/apiCalls/profile'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    search,
  },
  state: {
    isMobile: false,
    i18n: vuexI18n.store,
    navigation: false,
    registration: '',
    showSpinner: false,
    snackbar: {
      isSnackBarShown: false,
      text: false,
      color: 'primary',
    },
    currentTendersType: localStorage.getItem('currentTenders') || '',
    confirmDialog: {
      view: {
        isConfirmDialogShown: false,
        typeOfDialogItShownOn: '',
      },
      mainData: {
        title: '',
        text: '',
        button1: '',
        button2: '',
      },
    },
    regexps: {
      email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    },
    tender: {
      currentProcurementType: 'pricequotation',
      tendersFetchingLimit: 12,
    },
    ui: {
      isScrollToButtonHidden: true,
      appErrorCard: {
        isAppErrorCardShown: false,
        errorText: 'Something went wrong',
        accessBlockPresent: false,
      },
      sideBarPermanent: false,
    },
    starredTendersIds: [],
    user: {},
    nextSequenceToken: null,
  },
  getters: {
    userAvatar(state) {
      return state.user.avatar || require('@/assets/img/default_profile.png');
    },
  },
  mutations: {
    setNextSequenceToken(state, nextSequenceToken) {
      state.nextSequenceToken = nextSequenceToken;
    },

    changeScrollToButtonState(state, payload) {
      state.ui.isScrollToButtonHidden = payload
    },
    setLocale(state, locale) {
      state.i18n.locale = locale
    },
    navigation(state, isOpen) {
      state.navigation = isOpen
    },
    spinner(state, show) {
      state.showSpinner = show
    },
    openSnackBar(state, { text, color }) {
      state.snackbar.isSnackBarShown = true
      state.snackbar.text = text
      if (color) {
        state.snackbar.color = color
      }
    },
    changeRegistration(state, payload) {
      state.registration = payload
    },
    setCurrentTenderType(state, type) {
      state.currentTendersType = type
    },
    invokeConfirmDialog(state, mainData) {
      state.confirmDialog.mainData = mainData
    },
    changeConfirmDialogView(state, payload) {
      state.confirmDialog.view.isConfirmDialogShown = payload.isShown

      let type =
        typeof payload.type === 'string'
          ? payload.type
          : state.confirmDialog.view.typeOfDialogItShownOn

      state.confirmDialog.view.typeOfDialogItShownOn = type
    },

    setAppErrorCardState(state, payload) {
      state.ui.appErrorCard.isAppErrorCardShown = payload.state
      state.ui.appErrorCard.errorText = payload.errorText || 'Something went wrong'
      state.ui.appErrorCard.accessBlockPresent = payload.accessBlockPresent
    },
    setSideBarPermanentState(state, value) {
      state.ui.sideBarPermanent = value
    },
    setStarredTendersIds(state, ids) {
      state.starredTendersIds = ids;
    },
    addStarredId(state, id) {
      state.starredTendersIds.push(id);
    },
    removeStarredId(state, id) {
      const index = state.starredTendersIds.findIndex((itemId) => itemId === id);
      if (index > -1) {
        state.starredTendersIds.splice(index, 1);
      }
    },
    setUser(state, user) {
      state.user = user;
    }
  },
  actions: {
    async getStarredTendersIds({ commit }) {
      try {
        const { data } = await Profile.getStarredTendersIds();
        if (data.myStarredItems.data) {
          commit('setStarredTendersIds', data.myStarredItems.data.filter(item => item && item.id).map(item => item.id));
        } else {
          commit('setStarredTendersIds', []);
        }
      } catch (e) {
        console.error(e);
        commit('setStarredTendersIds', []);
      }
    },

    async getUserProfile({ state, commit }) {
      try {
        const { data } = await profileApi.getProfile(state.auth.user.sub);
        const user = data.getProfile;
        commit('setUser', user);
      } catch (e) {
        console.error(e);
      }
    },
  },
})
